import {FriendsManagerProvider} from '../../friends-manager';
import {SocketQuery} from '../../../../bayadic-shared-models/classes/system/sockets/SocketQuery.class';
import {Chat} from '../../../../bayadic-shared-models/chat/Chat';
import {AbstractChatMessage} from '../../../../bayadic-shared-models/classes/message/abstract-chat-message';
import {Item} from '../../../../bayadic-shared-models/classes/item/Item';
import * as Tools from '../../../../bayadic-shared-models/tools/Tools';
import * as Enums from '../../../../bayadic-shared-models/enums/Enums';
import { Friend } from '../../../../bayadic-shared-models/classes/user/friend/Friend';
export class FriendsSynchronizer{
    public friendsMgr: FriendsManagerProvider;
    public static getNewFriends = "getNewFriends";
    public static loadMyFriends = "loadMyFriends";
    public static syncFriendsAction = "syncFriends";
    public static deleteFriendAction = "deleteFriend";
    public syncing : boolean = false;
    constructor(friendsMgr: FriendsManagerProvider){
        this.friendsMgr = friendsMgr;
    }
    setSyncing(enable : boolean){
        this.syncing = enable;
    }
    isSyncing(){
        return this.syncing;
    }
    sync(){
        return false;
       let localFriendsIDs : Array<string> = [];
       for (let friend of this.friendsMgr.friends){
            localFriendsIDs.push(friend.userID);
       }
       if(!this.isSyncing()){
           this.friendsMgr.socketManager.
           asyncQuery<FriendSynResponse, any>(FriendsSynchronizer.syncFriendsAction,{'localFriendsIDs':localFriendsIDs}).
           then(result =>{
               this.setSyncing(false);
                for ( let createdFriend of result.created ){
                    this.friendsMgr.updateFriend(createdFriend);
                }
                for ( let deltedFriend of result.deleted ){
                    this.friendsMgr.deleteFriendLocally(deltedFriend);
                }
            });
        }
        this.setSyncing(true);
    }
    deleteFriend(friend : Friend){
        this.friendsMgr.socketManager.asyncQuery(
            FriendsSynchronizer.deleteFriendAction,friend.getSimpleModel());
    }
}

interface FriendSynResponse {
    created: string[],
    deleted: string[]
}